// System Settings Types (task 5.2)

export type SettingCategory = 'SECURITY' | 'NOTIFICATIONS' | 'INTEGRATIONS' | 'FEATURES';
export type SettingDataType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'JSON';

export interface SystemSetting {
  id: string;
  category: SettingCategory;
  key: string;
  value: string;
  description?: string | null;
  data_type: SettingDataType;
  validation_rules?: string | null;
  updated_by?: string | null;
  updated_at: string;
  created_at: string;
}

export interface CreateSettingRequest {
  category: SettingCategory;
  key: string;
  value: string;
  description?: string;
  data_type: SettingDataType;
  validation_rules?: string;
}

export interface UpdateSettingRequest {
  value: string;
}

export interface BulkUpdateRequest {
  settings: Record<string, string>;
}

export interface SettingHistory {
  id: string;
  setting_id: string;
  key: string;
  old_value?: string | null;
  new_value: string;
  changed_by?: string | null;
  changed_at: string;
}

export interface SettingHistoryResponse {
  data: SettingHistory[];
  total: number;
}

export interface SettingValidationRules {
  min?: number;
  max?: number;
  pattern?: string;
  required?: boolean;
  allowed_values?: string[];
}

/** Category metadata for display */
export const SETTING_CATEGORIES: { value: SettingCategory; label: string; description: string; icon: string }[] = [
  { value: 'SECURITY', label: 'Sécurité', description: 'Paramètres de sécurité et authentification', icon: 'shield' },
  { value: 'NOTIFICATIONS', label: 'Notifications', description: 'Configuration des notifications et alertes', icon: 'bell' },
  { value: 'INTEGRATIONS', label: 'Intégrations', description: 'Points de terminaison API externes', icon: 'link' },
  { value: 'FEATURES', label: 'Fonctionnalités', description: 'Activation/désactivation des fonctionnalités', icon: 'toggle' },
];

export const CATEGORY_COLORS: Record<string, string> = {
  SECURITY: 'bg-red-100 text-red-800',
  NOTIFICATIONS: 'bg-yellow-100 text-yellow-800',
  INTEGRATIONS: 'bg-blue-100 text-blue-800',
  FEATURES: 'bg-green-100 text-green-800',
};

export const DATA_TYPE_LABELS: Record<string, string> = {
  STRING: 'Texte',
  NUMBER: 'Nombre',
  BOOLEAN: 'Booléen',
  JSON: 'JSON',
};
